export default __webpack_public_path__ + "static/media/access-release.e1023ef5.svg";